import { Field } from "formik";
import { Form } from "react-bootstrap";
import { GroupTitle } from "../../../../StyledComponents";
import * as Yup from "yup";
// SubForms
import { SalutationSubForm, Schema as SalutationSchema } from '../subforms/Salutation';
import { NameAndContactSubForm, Schema as NameAndContactSchema } from '../subforms/NameAndContact';
import { DateOfBirthMandatorySubForm, Schema as DateOfMandatorySchema} from '../subforms/DateOfBirthMandatory';
import { SchoolEducationSubForm } from '../subforms/SchoolEducation';
import { NationalitySubForm } from '../subforms/Nationality';
import { OtherInformationSubForm, Schema as OtherInformationSchema } from '../subforms/OtherInformation';
import { DocumentsSubForm, Schema as DocumentsSchema } from '../subforms/Documents';

export const AusbildungSchema = (settings) => (
    Yup.object()
        .concat(SalutationSchema)
        .concat(NameAndContactSchema(settings))
        .concat(DateOfMandatorySchema(settings))
        .concat(OtherInformationSchema(settings))
        .concat(DocumentsSchema(settings))
);

export const Ausbildung = (props) => {
    const { colors, settings } = props;
    return (
        <>
            <Form.Text muted>Die im Folgenden mit * markierten Felder sind Pflichtfelder.</Form.Text>
            <GroupTitle>Kontaktdaten</GroupTitle>
            <Field component={SalutationSubForm} colors={colors} />
            <Field component={NameAndContactSubForm} colors={colors} settings={settings} />
            <GroupTitle>Persönliche Daten</GroupTitle>
            <Field component={DateOfBirthMandatorySubForm} colors={colors} settings={settings} />
            <Field component={SchoolEducationSubForm} colors={colors} settings={settings} />
            <Field component={NationalitySubForm} colors={colors} settings={settings} />
            <GroupTitle>Sonstiges</GroupTitle>
            <Field component={OtherInformationSubForm} colors={colors} />
            <GroupTitle>Dokumente</GroupTitle>
            <Field component={DocumentsSubForm} colors={colors} settings={settings} />
        </>
    );
}